module.exports = __webpack_public_path__ + "img/19.a521d5a7.png";